<template>
  <div id="terms-and-conditions">
    <NavBar :mainPage="mainPage" />
    <section id="terms-intro-section" class="termsintro-section" ref="tncstart">
      <Termsconditionsintro
        class="terms-in"
        :heading="headings.first"
        :paragraph="paragraph.first"
      />
    </section>
    <section id="terms-points">
      <Terms :paragraphs="paragraphs" :paras="paras" />

    </section>
    <!-- Add Merchant Agreement Section Here -->
  
    <!-- <section>
    <TransunionTnC />
     
    </section> -->
    <section id="foot" v-lazy:background-image ="require(`@/assets/background/footer_bg.png`)">
      <Footer />
    </section>
  </div>
</template>
<script>
  import Terms from "../common/terms";
  import Termsconditionsintro from "./terms-conditions-intro";
  // import TransunionTnC from "./transunion-tnc";
  export default {
    name: "Termsandconditions",
    components: {
      Terms,
      Termsconditionsintro,
      // TransunionTnC
    },
    data() {
      return {
        pdfLink: 'https://d3ba6ur3jzoh9w.cloudfront.net/losdocs/Merchant_Payment_Gateway_Agreement.pdf', // Your PDF link
        mainPage: false,
        headings: {
          first: "Terms and Conditions ",
        },
        paragraph: {
          first:
            "As a condition precedent to your right to access information from https://www.ftcash.com. The ftcash Terms of Service ('Terms') are a legally binding agreement between you, and Nomisma Mobile Solutions Pvt. Ltd using the trademark ftcash ('ftcash') and apply to your use of the ftcash account ('Account') and any ftcash products and services that you access using the ftcash Account (the 'ftcash Services'). ftcash offers a payment software platform that allows users to pay money using an internet connection. All funds transfers are performed by the Financial Institution Partner based on instructions issued through the ftcash software platform.",
        },
        paragraphs: {
          first:
            "It is important that you read and understand these Terms as they govern your use of the ftcash Services. These Terms contain a binding arbitration provision which affects your legal rights and may be enforced by the parties. By accessing or using the ftcash Services, you accept and agree to be bound by these Terms. Any disagreement with the mentioned terms and conditions requires you to immediately terminate your availing the ftcash services. If you do not agree to these Terms, you must immediately stop using the ftcash Services.",
          second:
            "We may amend these Terms at any time by posting a revised version on ftcash.com or any other website that we maintain for purposes of providing the ftcash Services. Amended Terms are effective starting from the time they are posted and you continuing the use of  ftcash Services constitutes as your acceptance of any amended Terms. We may notify you regarding upcoming changes in the Terms & Conditions by email. Capitalized terms used in these Terms have the meaning assigned to them in Definitions section.",
        },
        paras: [
          {
            title: "Using ftcash",
            paragraph:[
              {
                subpoint: false,
                line:
                  "ftcash provides a software platform that gives you the ability to make electronic payments to other ftcash users primarily merchants who are also using ftcash allows you to send payment instructions to the Financial Institution Partner (which may be a credit card or debit processor).",
              },
            ]
          },
          {
            title: "ftcash Accounts",
            paragraph:[
              {
                subpoint: false,
                line:
                  'ftcash offers Personal, Business, Government, and Non-profit accounts (each an "Account"). If you open a Business, Government, or Non-profit Account, you agree that you are not opening or using this Account primarily for personal, family, or household purposes.',
              },
            ]     
          },
          {
            title: "Membership Eligibility:",
            paragraph:[
              {
                subpoint: false,
                line:
                  'Use of the Website is available only to persons who can enter into legally binding contracts under the Indian Contract Act, 1872. Persons who are “incompetent to contract” within the meaning of the Indian Contract Act, 1872 including minors, un-discharged insolvents and persons of unsound mind are not eligible to use the Website. Any person under the age of 18 shall not register as a Borrower on the Website and shall not transact on or use the Website. ftcash reserves the right to terminate any person’s membership and/or refuse to provide such person with access to the Website if it is brought to ftcash notice or if it is discovered that such person is not eligible to use the Website. In case you are using the Website and opening an account on the Website on behalf of an incorporated entity, it is presumed that you have been authorized by the entity and your use of the Website shall bind the entity with respect to these Terms. If the user violates any of these Terms and Conditions from time to time and such revision/modification shall be effective upon posting by us on the website. The member should agree to be bound to any changes to this Terms & Conditions when they use such services after such modification is posted. It is therefore important that the members review the Terms & Conditions regularly upon each use of the services to ensure any updates as to changes. The Website is intended for users within India only.',
              },
            ]   
          },
          {
            title: "Use of Website:",
            paragraph:[
              {
                subpoint: false,
                line:
                  'The Borrower agrees, undertakes, and covenants that, during the use of the Website, the Borrower shall not host, display, upload, modify, publish, transmit, update, or share any information that:',
              },
              {
                subpoint: true,
                line:[
                  {
                    point:'Belongs to another person or entity and to which the Borrower does not have any right.'
                  },
                  {
                    point:'Is grossly harmful, harassing, blasphemous, defamatory, obscene, pornographic, paedophilic, libellous, invasive of another’s privacy, hateful or racially or ethnically objectionable, disparaging or encouraging money laundering or gambling, or otherwise unlawful in any manner whatsoever.'
                  },
                  {
                    point: 'Is misleading in any way.'
                  },
                  {
                    point: 'Involves the transmission of “junk mail”, “chain letters”, or unsolicited mass mailing or “spamming”.'
                  },
                  {
                    point: 'Infringes upon or violates any third party’s rights including, but not limited to, intellectual property rights, rights of privacy (including without limitation unauthorized disclosure of a person’s name, email address, physical address, or phone number), or rights of publicity.'
                  },
                  {
                    point: 'Tries to gain unauthorized access or exceeds the scope of authorized access to the Website or to profiles, blogs, communities, account information, bulletins, or other areas of the Website or solicits passwords or personally identifying information for commercial or unlawful purposes from other Borrowers.'
                  },
                  {
                    point: 'Interferes with another Borrower’s use and enjoyment of the Website.'
                  },
                  {
                    point: 'Refers to any website or URL that, in ftcash sole discretion, contains material that is inappropriate for the Website or any other website, contains content that would be prohibited, or violates the letter or spirit of these Terms.'
                  },
                  {
                    point: 'Contains software viruses or any other computer codes, files, or programs designed to interrupt, destroy or limit the functionality of any computer resource; or contains any trojan horses, worms, or other computer programming routines that may damage, detrimentally interfere with, diminish the value of, surreptitiously intercept or expropriate any system, data or personal information.'
                  },
                ]
              },
            ]         
          },
          {
            title: "Indemnification:",
            paragraph:[
              {
                subpoint: false,
                line:
                  'The Borrower shall indemnify, save and hold harmless ftcash, its owner, licensors, licensee, affiliates, contractors, subsidiaries, group companies (as applicable) and their respective officers, directors, agents, and employees, from any claim or demand, or actions including reasonable attorneys’ fees, made by any third party or penalty imposed due to or arising out of the Borrower’s breach of these Terms, Privacy Policy and other policies, or the Borrower’s violation of any law, rules or regulations or the rights (including infringement of any intellectual property rights) of a third party. ftcash reserves the right, at your expense, to assume the exclusive defence and control of any matter for which you are required to indemnify ftcash, including rights to settle, and you agree to cooperate with ftcash’ defence and settlement of these claims. ftcash will use reasonable efforts to notify you of any claim, action, or proceeding brought by a third party that is subject to the foregoing indemnification upon becoming aware of it.',
              },
            ]         
          },
          {
            title: "Termination:",
            paragraph:[
              {
                subpoint: false,
                line:
                  'ftcash, in its sole discretion, may modify, suspend, or terminate access to, all or any portion of the Website at any time for any reason including termination for breach of any of these Terms. None of the Borrower’s content shall remain accessible on the Website upon termination. This information cannot be recovered by the Borrower, once the account is terminated. The disclaimer of warranties, the limitation of liability, and the governing law provisions shall survive any termination of these Terms.',
              },
            ]         
          },
          {
            title: "Disclaimer of Warranties:",
            paragraph:[
              {
                subpoint: false,
                line:
                  'The website and all information, content, materials, and services included on or otherwise made available to the borrower through the website (collectively, the “contents”) are provided by ftcash on an “as is,” “as available” basis, without representations or warranties of any kind. ftcash makes no representations or warranties of any kind, express or implied, as to the operation of the website, the accuracy or completeness of the contents and the accuracy of the information or receipt of loans. ftcash shall have no responsibility for any damage to the borrower’s computer system or loss of data that results from the download of any content, materials, document or information or any other losses incurred by the borrower for failure to receive loans. The borrower expressly agrees that the use of the website is at the borrower’s sole risk. ftcash will not be liable for any damages of any kind arising from the use of the website or the services or the contents including, without limitation, direct, indirect, consequential, punitive, and consequential damages unless otherwise specified in writing. To the full extent permitted by law, ftcash disclaims any and all representations and warranties with respect to the website and its contents, whether express or implied, including, without limitation, warranties of title, merchantability, and fitness for a particular purpose or use. No advice or information, whether oral or written, obtained by you from ftcash through or from the service will create any warranty not expressly stated in these Terms & Conditions.',
              },
            ]         
          },
          {
            title: "Limitation of Liability:",
            paragraph:[
              {
                subpoint: false,
                line:
                  'In no event shall Ftcash, its directors, employees or agents, be liable for any special, incidental, indirect or consequential damages whatsoever resulting from any (i) errors, mistakes, or inaccuracies of content; (ii) personal injury or property damage, of any nature whatsoever, resulting from the borrower’s access to and use of the website; (iii) any unauthorized access to or use of the secure servers and/or any and all personal and/or business and/or financial information stored therein; (iv) any interruption or cessation of transmission to or from the website; (v) any bugs, viruses, trojan horses, or the like, which may be transmitted to or through the website by any third party; and/or (vi) any errors or omissions in any content or for any loss or damage of any kind incurred as a result of the use of any content posted, emailed, transmitted, or otherwise made available via the website, whether based on warranty, contract, tort, or any other legal theory, and whether or not ftcash is advised of the possibility of such damages. Subject to the above and notwithstanding anything to the contrary contained in these terms, the maximum aggregate liability (whether in contract, tort (including negligence) or equity) of ftcash vis-à-vis any borrower, regardless of the form of claim, shall be limited to the aggregate of fees, if any, paid by the borrower to ftcash. The foregoing limitations of liability will apply notwithstanding the failure of the essential purpose of any limited remedy herein. This limitation of liability clause shall prevail over any conflicting or inconsistent provision contained in any of the documents/content comprising these Terms &amp; Conditions. It is up to you to take precautions to ensure that whatever you select for your use is free of such items as viruses, worms, malware, Trojan horses, and other items of a destructive nature.',
              },
            ]         
          },
          {
            title: "Severability:",
            paragraph:[
              {
                subpoint: false,
                line:
                  'If a provision of these Terms is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect. If any unlawful and/or unenforceable provision would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect.',
              },
            ]         
          },
          {
            title: "Content and Intellectual Property Rights:",
            paragraph:[
              {
                subpoint: false,
                line:
                  'ftcash solely and exclusively owns copyrights, trademarks, service marks, logos, trade names, and other intellectual and proprietary rights associated with the Website and content on the Website and is protected under Indian law. You hereby acknowledge that the Website constitutes original work and has been developed, compiled, prepared, revised, selected, and arranged by ftcash through the application of methods and standards of judgment developed and applied through the expenditure of substantial time, effort, and money and constitutes the valuable intellectual property of us and such others. You thereby agree to protect the proprietary rights of ftcash during and after the term of these Terms. You may not selectively download portions of the Website without retaining the copyright notices. You may download material from the Website only for your own personal use and for no commercial purposes whatsoever. Any infringement shall lead to appropriate legal proceedings against you at the appropriate forum for seeking all available remedies under applicable laws of the country.',
              },
            ]         
          },
          {
            title: "Force Majeure:",
            paragraph:[
              {
                subpoint: false,
                line:
                  'ftcash shall not be liable to you for its failure to perform or for the delay in providing you access to your Account or to the Website, to the extent such failure or delay results from causes beyond its control, including, without limitation, acts of God, fires, explosions, wars or other hostilities, insurrections, revolutions, strikes, labour unrest, earthquakes, floods, epidemics or quarantine restrictions, unforeseeable governmental restrictions or controls or a failure by a third party hosting provider or internet service provider or on account of any change or defect in the software and/or hardware of your computer system. You understand and agree we will not be held responsible for any losses or damages resulting from suspension of service due to extraordinary events or circumstances beyond our control. In such an event, ftcash may suspend the ftcash Services and access to your Account and the Financial Institution Partner may suspend service',
              },
            ]         
          },
          {
            title: "Assignment:",
            paragraph:[
              {
                subpoint: false,
                line:
                  'It is expressly agreed by the parties that ftcash may assign all or part of its rights or duties under these Terms without such assignment being considered a change to these Terms and without notice to you, except to the extent provided by law. You may not transfer or assign any rights or obligations you have under these Terms. ftcash and the Financial Institution Partner reserve the right to transfer or assign any rights or obligations under these Terms at any time.',
              },
            ]         
          },
          {
            title: "Your privacy",
            paragraph:[
              {
                subpoint: false,
                line:
                  'Your privacy is very important to ftcash and the Financial Institution Partner. Your registration for the account confirms that you have read and accepted the ftcash Privacy Policy and Financial Institution Partners Notice of Your Financial Privacy Rights.',
              },
            ]         
          },
          {
            title: "Accuracy of information",
            paragraph:[
              {
                subpoint: false,
                line:
                  'When you register for an Account, you may be required to provide information that will allow us to verify your identity, including but not limited to: a valid physical address (not including P.O. Boxes or commercial mail receiving agencies), phone number, bank account information, a copy of your photo identification, proof of business document and your PAN card number. Your registration confirms your agreement to provide true and accurate information to ftcash and update it as and when necessary. Any failure to do so or any discrepancy in the accuracy of the information at any given point allows the service provider to take appropriate actions or levy appropriate charges.',
              },
            ]        
          },
          {
            title: "Authentication",
            paragraph:[
              {
                subpoint: false,
                line:
                  'You may be required to provide additional information or documentation to allow ftcash for verifying your identity and/or your account information. Your registration also authorizes ftcash verify your information against third party databases or other sources if they need to do arises.',
              },
            ]     
          },
          {
            title: "Password security",
            paragraph:[
              {
                subpoint: false,
                line:
                  'ftcash will never ask you for your Account credentials. We request you to not share your Account login information, password, and PIN. You are solely responsible for keeping your Account login information, password, and PIN secure. If you share your Account credentials with another person, you are responsible for all activity they conduct using your Account, regardless of whether or not you authorized their activity.',
              },
            ]          
          },
          {
            title:
              "Authorization to debit your linked bank or credit union account",
            paragraph:[
              {
                subpoint: false,
                line:
                  'If you link a bank account or a credit / debit card to your Account, you are authorizing ftcash and the Financial Institution Partner to initiate an electronic transfer from your linked bank / debit card / credit card account in the amount you specify. You are solely responsible for complying with any terms set by your bank or credit card provider with respect to your account, including any fee terms, such as non-sufficient fund or overdraft fee terms. If you are entitled to a Reversal, refund, or other adjustment associated with a payment you made using the ftcash Services, you also authorize ftcash and the Financial Institution Partner to credit your linked account to complete that transaction.',
              },
            ]           
          },
          {
            title: "No endorsement of products",
            paragraph:[
              {
                subpoint: false,
                line:
                  'Under no circumstances does ftcash endorse or provide guarantee for any individual or entity using the ftcash system or ftcash services. Any third-party offers, goods or services featured on ftcash websites are neither sponsored nor endorsed by ftcash in any way. Information regarding third party offers, goods, and services is provided on ftcash websites for informational purposes only, and may not be true, accurate, or reliable.',
              },
            ]
          },
          {
            title: "Consent to receive electronic Communications",
            paragraph:[
              {
                subpoint: false,
                line:
                  'By opening an Account and/or using the ftcash Services, you consent to receive all Communications from ftcash electronically and you confirm that you can access, receive and retain such Communications. "Communications" means all communications including terms, disclosures, notices, and statements that ftcash provides to you in connection with your Account and your use of the ftcash Services. ftcash provides communications to you by posting them on ftcash.com, by emailing them to you at the email address or by sending text messages or SMS to your mobile number associated with your Account or provided by you while availing any ftcash Services.',
              },
            ]  
          },
          {
            title: 'Data from Credit Bureaus',
            paragraph:[
              {
                subpoint: false,
                line:
                'ftcash is a lawfully appointed agent and it has agreed to be the agent for the purposes to receive the data from TU CIBIL/Highmark/Equifax on the customer’s behalf and use it in a manner consistent with the end-use policy. The customer shall not hold the agent or TU CIBIL/Highmark/Equifax responsible or liable for any loss, claim, liability, or damage of any kind resulting from, arising out of, or in any way related to:',
              },
              {
                subpoint: true,
                line:[
                  {
                    point:'delivery of the Product or sharing the product with respective partners'
                  },
                  {
                    point:'any use by the agent of the contents, in whole or in part, of the product.'
                  },
                  ]
              },
              {
                subpoint: false,
                line:
                "In their acceptance to ftcash the customer is recording their consent to provide instructions to obtain their Consumer Credit Information from their personal credit profile.",
              },
            ]
          },
          {
            title: "Specific to TU CIBIL, the customer agrees to grant ftcash the consent as captured in the following letter to TU CIBIL and signs off the same :",
            paragraph:[
              {
              subpoint:false,
              line:
                  'To,'
              },
              {
              subpoint:false,
              line:
                'TransUnion CIBIL Limited',
              },
              {
              subpoint:false,
              line:
                '[Formerly known as Credit Information Bureau (India) Limited]',
              },
              {
              subpoint:false,
              line:
                '19th Floor, One World Centre Tower-2A-2B,',
              },
              {
              subpoint:false,
              line:
                '841 Senapati Bapat Marg,',
              },
              {
              subpoint:false,
              line:
                'Lower Parel,',
              },
              {
              subpoint:false,
              line:
                'Mumbai – 400 013',
              },
            {
              subpoint:false,
              line:
                '       Sub:   Grant of Consent      '
            },
            {
              subpoint:false,
              line:
                'Dear Sirs,',
            },
            {
              subpoint:false,
              line:
                'In connection with submission of the application for my credit information (“Consumer Credit Information”) and other related credit products (Credit Products) offered by CIBIL through Nomisma Mobile Solutions Pvt. Ltd ("ftcash") (referred to as the “Company”) and delivery of the Consumer Credit Information and Credit Products to the Company, I hereby acknowledge and agree to the following:',
            },
            {
              subpoint:true,
              line:[
                  {
                    point:'The Company is my lawfully appointed agent and he / it has agreed to be my agent for the purposes, including, without limitation, to receive the Consumer Credit Information and Credit Products from TUCL on my behalf and use it and the Company has granted its consent for being appointed for the aforesaid purpose.'
                  },
                  {
                    point:'I grant my unconditional consent to the Company to receive the Consumer Credit Information and Credit Products from TUCL on my behalf and the Company has granted its consent for being appointed for the aforesaid purpose. I hereby represent and acknowledge that the Terms of Understanding in relation to the use of the Consumer Credit Information and Credit Products has been agreed between me and the Company.'
                  },
                  {
                    point:'I hereby expressly grant unconditional consent to, and direct, TUCL to deliver my Consumer Credit Information and Credit Products to the Company on my behalf.'
                  },
                  {
                    point:'I agree that my consent shall be stored by the Company on a permanent basis and shall be verifiable from time to time. I understand that the Company cannot access the Consumer Credit Information for more than 6 months on a single Consumer Consent and the same shall be required to be refreshed every six (6) months. Company can store the Consumer Credit Information only for (i) a limited time period of six months or (ii) till such time the credit information is required to be retained to satisfy the purpose for which it was provided or (iii) until I withdraw my consent to store such Consumer Credit Information, whichever is earlier and thereafter, the stored Consumer Credit Information shall be deleted, purged, expunged by the Company.'
                  },
                  {
                    point:'I shall not hold TUCL  responsible or liable for any loss, claim, liability, or damage of any kind resulting from, arising out of, or in any way related to: (a) delivery of my Consumer Credit Information and Credit Products to the Company ; (b) any use, modification or disclosure by the Company  of the contents, in whole or in part, of my Consumer Credit Information or Credit Products , whether authorized or not; (c) any breach of confidentiality or privacy in relation to delivery of my Consumer Credit Information  to the Company.'
                  },
                  {
                    point:'I acknowledge and accept that TUCL has not made any promises or representations to me in order to induce me to provide my Consumer Credit Information   or seek any consent or authorization in this regard.'
                  },
                  {
                    point:'I agree that I may be required to record my consent / provide  consent  electronically and in all such cases I understand that by clicking on the "I Accept" button below, I am providing "written  consent " to [COMPANY] authorizing [COMPANY] to obtain my Consumer Credit Information from my personal credit profile from TransUnion CIBIL LIMITED. I further authorize [COMPANY] to obtain such information solely to confirm my identity and display my Consumer Credit Information to me.  Further in all such cases “By checking this box and clicking on the ‘Authorize button,  I agree to the terms and conditions, acknowledge receipt of TUCL privacy policy and agree to its terms, and confirm my  authorization for [COMPANY] to obtain my Consumer Credit Information and Credit Products.'
                  },
                  {
                    point:'I understand that in order to deliver the product to me, I hereby authorize [COMPANY], to obtain my Consumer Credit Information and Credit Products from TUCL.'
                  },
                  {
                    point:'By submitting this registration form, I understand that I am providing express written consent  for [COMPANY] to request and receive information about me from third parties, including but not limited to a copy of my consumer credit report and score from consumer reporting agencies, at any time for so long as I have an active [COMPANY] account. I further authorize [COMPANY] to retain a copy of my information for use in accordance with [COMPANY’S] Terms of Use and Privacy Policy.'
                  },
                  {
                    point:'I UNDERSTAND THAT THE PRODUCT IS PROVIDED ON AN “AS-IS”, “AS AVAILABLE” BASIS AND TUCL EXPRESSLY DISCLAIMS ALL WARRANTIES, INCLUDING THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.'
                  },
                  {
                    point:'I shall not sue or otherwise make or present any demand or claim, and I irrevocably, unconditionally and entirely release, waive and forever discharge TUCL , its officers, directors, employees, agents, licensees, affiliates, successors and assigns, jointly and individually (hereinafter “Releasee”), from any and all manner of liabilities, claims, demands, losses, claims, suits, costs and expenses (including court costs and reasonable attorney fees) (“Losses”), whatsoever, in law or equity, whether known or unknown, which I ever had, now have, or in the future may have against the Releasee with respect to the submission of my Consumer Credit Information or Credit Products  and / or my decision to provide TUCL with the authority to deliver my Consumer Credit Information  and Credit Products to the Company . I agree to defend, indemnify, and hold harmless the Releasee from and against any and all Losses resulting from claims made against TUCL L by third parties arising from and in connection with this letter.'
                  },
                  {
                    point:'I agree that the terms of this confirmation letter shall be governed by the laws of India and shall be subject to the exclusive jurisdiction of the courts located in Mumbai in regard to any dispute arising hereof. TUCL is entitled to assign its rights hereunder to any third person without taking my prior written consent. '
                  }, 
              ]
            },
            {
              subpoint:false,
              line:
                'Yours faithfully,',
            },
            {
              subpoint:false,
              line:
                'Signature             :____________________________',
            },
            {
              subpoint:false,
              line:
                'Name                   :____________________________',
            },
            {
              subpoint:false,
              line:
                'Address                : ____________________________',
            },
            {
              subpoint:false,
              line:
                'CC:         Nomisma Mobile Solutions Pvt. Ltd ("ftcash")',
            },
            {
              subpoint:false,
              line:
                'Address : A-405, 4th Floor, Boomerang Building, Yadav Nagar, Chandivali Farm Road, Chandivali. Andheri (East). Mumbai-400072;',
            },
            {
              subpoint:false,
              line:
                'Opposite Mittal Industrial Estate;',
            },
            {
              subpoint:false,
              line:
                'Andheri Kurla Road, Marol Andheri East',
            },
            {
              subpoint:false,
              line:
                'Mumbai, Maharashtra 400059',
            },
            ]
          },
          {
            title: "USER CONSENTS",
            paragraph:[
              {
                subpoint: false,
                line:
                  'To,'
              },
              {
                subpoint: false,
                line:
                  'Partner Lender(s)'
              },
              {
                subpoint: false,
                line:
                  '(Details of all the Partner Lender(s) are available on https://www.ftcash.com/)'
              },
              {
                subpoint: false,
                line:
                  'Subject: User consents'
              },
              {
                subpoint: false,
                line:
                  'I/We, (the “Borrower(s)”), has/have applied to avail a term loan facility (“Term Loan Facility”) from the Partner Lender(s). In this regard, I/We hereby irrevocably and unconditionally give my/our consent and instructions as follows:'
              },
              {
                subpoint:true,
                line:[
                  {
                    point: ' (i) I/We authorise the Partner Lender(s) to collect, use, store, process and share all information in relation to my/our contract/arrangements available with the Partner Lender(s) with Nomisma Mobile Solutions Private Limited (“Referral Partner”) and/or any other third party, in relation to, and for the purpose of determining my/our eligibility for the Term Loan Facility and/or for ongoing credit and risk assessment undertaken/ to be undertaken by the Partner Lender(s) during the tenure of the Term Loan Facility and/or for the purposes of recovery of the Term Loan Facility granted to me/us by the Partner Lender(s). Such information shall include, but is not limited to: (a) personal details including my/our name, age, email id, PAN, Aadhar details, contact details, location, PIN code, GSTIN and bank account details; (b) information in relation to my/our contract/arrangements with the Partner Lender(s); (c) details of my/our repayment/payments to the Partner Lender(s); (d) details of repayment cycle; (e) details of my/our disputes with the Partner Lender(s); and (f) any penalties levied on me/us by the Partner Lender(s) (collectively, the “Borrower Data”). '
                  },
                  {
                    point: ' (ii) I/We hereby agree and acknowledge that the Borrower Data can be collected, used, processed, stored and shared by the Partner Lender(s) with the Referral Partner any/or other third party and in each case and their agents, representatives and service providers, as and when required by the Partner Lender(s), in relation to the Term Loan Facility availed by me/us from such Partner Lender(s) till such time I/We: (a) repay to the Partner Lender(s) all outstanding payments in relation to the Term Loan Facility availed by me/us from such Partner Lender(s) or (b) remain associated with such the Partner Lender(s) (whichever is earlier).'
                  },
                  {
                    point:'(iii) I/We hereby agree and acknowledge that in the event where I/We revoke/withdraw my/our consent to collect, store, use, process or share any information in relation to me/us that is in the nature of Borrower Data and/or personal data/personal information, I/We shall intimate the Partner Lender(s) in writing, and shall immediately cease the use of the Term Loan Facility availed from such Partner Lender(s) and make payments of all amounts in relation to the Term Loan Facility  including, without limitation, the disbursed amount and the interest thereon, including any other charges and fees as specified in the facility documents that I/We have entered with the Partner Lender(s) that have remain unpaid (“Owed Amounts”);'
                  },
                  {
                    point:'(iv) I/We hereby acknowledge and agree that I/We may request to delete or erase any personal information (including, but not limited to, Borrower Data) to the extent permitted to be requested under applicable laws and the Partner Lender(s) shall, and shall ensure that the Referral Partner and/or the relevant third parties shall, delete or erase such personal information as requested by me/us (provided however that I/We acknowledge and agree that notwithstanding any such request by me/us, the Partner Lender(s) and/or the relevant third parties may retain such information to the extent required under applicable laws or as per statutory or regulatory requirements);'
                  },
                  {
                    point:'(v) I/We hereby agree and acknowledge that in the event where I/We do not provide my/our consents for collection, storage, processing, sharing and use of Borrower Data as request above, the Partner Lender(s) may, at its sole discretion, not provide or cease to provide the Term Loan Facility to me/us; and'
                  },
                  {
                    point:'(vi) I/We hereby agree and acknowledge that this consent letter forms a part of the agreement/ facility document to be entered into by me/us in relation to the Term Loan Facility and shall be designated as a "facility document" by the respective Partner Lender(s). '
                  },
                  {
                    point:'(vii) This consent letter will be governed by Indian law.'
                  },
                  {
                    point:'(viii) If any dispute(s) or difference(s) shall arise between me/us and the Partner Lender, in connection with or arising out of or relating to this consent letter, the same shall be settled in accordance the jurisdiction and/or dispute resolution clause accepted by me/us under the facility documents entered by me/us with the Partner Lender(s).'
                  },
                  {
                    point:'(ix) Clause (viii) is only for the benefit of the Partner Lender(s) only. I/We irrevocably and generally consent in respect of any procee dings anywhere in connection with this consent letter to the giving of any relief or the issue of any process in connection with those proceedings, including, without limitation, the making, enforcement or execution against any assets whatsoever (irrespective of their use or intended use) of any order or judgment which may be made or given in those proceedings. To the fullest extent allowed by law, the Partner Lender(s) may take concurrent proceedings in any number of jurisdictions.'
                  },
                  {
                    point:'(x) I shall be liable to pay a non-refundable Processing Fee and Credit Shield Insurance Premium and other Insurance Premiums, as mentioned in the Sanction Letter;'
                  },
                  {
                    point:'(xi) I hereby understand that, except for the loan instalments and other charges as mentioned in the Sanction Letter or specified in the loan documents, I am not required to pay any amount in cash or anything in kind to employees or any other person;'
                  },
                  {
                    point:'(xii) Partner Lender shall have the right to disclose information relating to me, loan availed of or to be availed of by me, obligations assumed or to be assumed by me in relation thereto and default, if any, committed by me in discharge thereof to the Reserve Bank of India, Income Tax Authorities, Credit Bureau(s), Credit Rating Agencies, other financial institutions or any other government or regulatory authorities, statutory authorities, quasi-judicial authorities, and any other agency having a confidential agreement with Partner Lender in order to respect the privacy of the borrower data;'
                  }, 
                  {
                    point:'(xiii) I hereby give my consent to Partner Lender and to the Co-Lenders, if any, to pull out credit reports or similar documents from any credit information company(ies) by disclosing/ sharing the information/ documents furnished by me at the time of sanctioning of the loan and at any time during the currency of the loan. I further give my consent to Partner Lender to get these credit reports pulled out by its empanelled partners. I understand and agree that these credit reports and documents forming a part thereof or ancillary thereof could/ would be shared by Partner Lender with other organizations or third parties in the normal course of their business.'
                  },
                  {
                    point:'(xiv) I hereby submit voluntarily at my own discretion, the physical copy of Aadhaar card/physical e-Aadhaar / masked Aadhaar/ offline electronic Aadhaar xml as issued by UIDAI (Aadhaar), to Partner Lender, if any, for the purpose of establishing my identity/ address proof; And I also, hereby consent to Partner Lender, if any, for verification of my to establish its genuineness through such acceptable manner as per UIDAI or under any Act or law from time to time. The consent and purpose of collecting Aadhaar has been explained to me in local language. Partner Lender has informed me that my Aadhaar submitted shall not be used for any purpose other than mentioned above, or as per requirements of law. Partner Lender has informed me that this consent and my Aadhaar will be stored along with my account details within Partner Lender and the Co-Lender, if any.'
                  },
                  {
                    point: '(xv) I hereby understand that all information including but not limited to personal details, employment details, business details, etc. furnished by me shall be subjected to verification and scrutinization by Partner Lender and may be modified accordingly by Partner Lender, if any discrepancies are found.'
                  },
                  {
                  point: '(xvi) By proceeding, I confirm that I have read and agree to the disclaimer, Aadhaar consent and the terms and conditions of the application and give my consent to hereby authorize Partner Lender and its representatives to contact me/us through calls, SMS/ WhatsApp and this shall override any registration by me under DNC/NDNC.'
                  },
                  {
                    point: '(xvii) I give my consent to Partner Lender and its representatives to Call, SMS or communicate via WhatsApp regarding my application. This consent overrides any registration for DNC / NDNC.'
                  },
                ]
              },
              {
                subpoint: false,
                line:
                  'Acknowledgment and acceptance of this user consent by the Borrower(s) by way of entering OTP sent on the registered mobile number of the Borrower(s): ',
              },
              {
                subpoint: false,
                line:
                  'I/We has/ have carefully read and understood the consents and instructions specified above and would like to confirm the same.',
              },
            ]
          },
          {
            title: "USER CONSENTS ",
            paragraph:[
              {
                subpoint: false,
                line:
                  'To:',
              },
              {
                subpoint: false,
                line:
                  'Nomisma Mobile Solutions Private Limited (the “Referral Partner”)',
              },
              {
                subpoint: false,
                line:
                  'A-405, 4th Floor, Boomerang Building, Yadav Nagar, Chandivali Farm Road, Chandivali. Andheri (East). Mumbai-400072',
              },
              {
                subpoint: false,
                line:
                  'Cc: Partner Lender(s)',
              },
              {
                subpoint: false,
                line:
                  '(Details of all the Partner Lender(s) are available on https://www.ftcash.com/)',
              },
              {
                subpoint: false,
                line:
                  'Subject: User consents',
              },
              {
                subpoint: false,
                line:
                  'I/We, (the “Borrower(s)”), has/have applied to avail a term loan facility (“Term Loan Facility”) from the Partner Lender(s) of the Referral Partner. In this regard, I/We hereby irrevocably and unconditionally give my/our consent and instructions as follows: ',
              },
              {
                subpoint:true,
                line:[
                  {
                    point: ' (i) I/We authorise the Referral Partner to collect, use, process, store and share the following information with the Partner Lender(s) who would/ will be providing the Term Loan Facility to me/us and/or any other third party, in relation to, and for the purpose of determining my/our eligibility for, the Term Loan Facility and/or for ongoing credit and risk assessment undertaken/ to be undertaken by the Partner Lender(s) during the tenure of the Term Loan Facility availed by me/us from such Partner Lender(s). Such information shall include, but is not limited to: (a) personal details including my/our name, age, email id, PAN, Aadhar details, contact details, location, PIN code, GSTIN and bank account details; (b) information in relation to my/our contract/arrangements with the Referral Partner; (c) details of my/our settlements and customer charge or other amounts collected/received by the Referral Partner or a combination thereof; (d) details of my/our payment cycle with Referral Partner; (e) details of my/our disputes with the Referral Partner; and (f) any penalties levied on me/us by the Referral Partner (collectively, the “Borrower Data”). '
                  },
                  {
                    point: ' (ii) I/We hereby agree and acknowledge that the Borrower Data can be collected, used, processed, stored by the Referral Partner and the Partner Lender(s) and can also be shared by the Referral Partner with the Partner Lender(s) and/or any other third party in relation to the Term Loan Facility availed by me/us from such Partner Lender(s) till such time I/We: (a) repay to the respective Partner Lender(s) all outstanding payments in relation to the Term Loan Facility availed by me/us from such Partner Lender(s) or (b) remain associated with such Partner Lender(s) (whichever is earlier).'
                  },
                  {
                    point: ' (iii) I/We authorise the Partner Lender(s) and/or the Referral Partner for a one-time access to the camera, microphone, location, or any other facility of my electronic devices for the purpose of on-boarding/KYC requirements for availing the Term Loan Facility from the respective Partner Lender(s). '
                  },
                  {
                    point: ' (iv) I/We hereby agree and acknowledge that in the event where I/We revoke/withdraw my/our consent to collect, store, use, process or share any information in relation to me/us that is in the nature of Borrower Data and/or personal data/personal information to the Partner Lender(s) and/or the Referral Partner and/or any third party, I/We shall intimate the respective Partner Lender(s) and the Referral Partner in writing, and shall immediately cease the use of the Term Loan Facility and make payments of all outstanding amounts in relation to the Term Loan Facility owed by me/us to the respective Partner Lender(s).'
                  },
                  {
                    point: ' (v) I/We hereby agree and acknowledge that I/We may request to delete or erase any personal information (including, but not limited to, Borrower Data) to the extent permitted to be requested under applicable laws and the Partner Lender(s) and/or the Referral Partner will, and will ensure that the relevant third party will, delete or erase such personal information as requested by me/us (provided however that I/We acknowledge and agree that notwithstanding any such request by me/us, the Partner Lender(s) and/or the Referral Partner and/or the relevant third parties may retain such information to the extent required under applicable laws or as per statutory or regulatory requirements).'
                  },
                  {
                    point: ' (vi) I/We hereby agree and acknowledge that in the event where I/We do not provide my/our consents for collection, storage, processing, sharing and use of Borrower Data as mentioned above, the Partner Lender(s) may, at its/their sole discretion, shall not provide or cease to provide the Term Loan Facility to me/us.'
                  },
                  {
                    point: ' (vii) I/We hereby agree and acknowledge that this consent letter forms a part of the agreement/ facility document to be entered into by me/us in relation to the Term Loan Facility and shall be designated as a "facility document" by the respective Partner Lender(s).'
                  },
                  {
                    point: ' (viii) This consent letter will be governed by Indian law.'
                  },
                  {
                    point: ' (ix) If any dispute(s) or difference(s) shall arise between (a) me/us and the Partner Lender(s) or (b) me/us and the Referral Partner, in connection with or arising out of or relating to this consent letter, the same shall be governed in accordance the governing law, jurisdiction and/or dispute resolution clause accepted by me/us (i) under the facility documents entered by me/us with the Partner Lender(s) and (ii) under the service agreement entered by me/us with the Referral Partner, respectively'
                  },
                  {
                    point: ' (x) Clause (ix) is only for the benefit of Referral Partner and the Partner Lender(s). I/We irrevocably and generally consent in respect of any proceedings anywhere in connection with this consent letter to the giving of any relief or the issue of any process in connection with those proceedings, including, without limitation, the making, enforcement or execution against any assets whatsoever (irrespective of their use or intended use) of any order or judgment which may be made or given in those proceedings. To the fullest extent allowed by law, the Partner Lender(s) and/or the Referral Partner may take concurrent proceedings in any number of jurisdictions.'
                  },
                ]
              },
              {
                subpoint: false,
                line:
                  'Acknowledgment and acceptance of this user consent by the Borrower(s) by way of entering OTP sent on the registered mobile number of the Borrower(s):',
              },
            ]         
          },
          {
            title: "Notices to You",
            paragraph:[
              {
                subpoint: false,
                line:
                  'A Communication will be considered to be received by you within 24 hours after the time we post it to our website or email it to you.',
              },
            ]        
          },
          {
            title: "Requesting Paper Copies",
            paragraph:[
              {
                subpoint: false,
                line:
                  'You may request a paper copy of a Communication that we provided to you digitally by contacting us as mentioned in Section 15 below. We will send it to the mailing address provided by you for your ftcash Account. ftcash may charge you a fee of Rs. 100 for each paper copy of a Communication sent to you.',
              },
            ]    
          },
          {
            title: "Withdrawing Consent",
            paragraph:[
              {
                subpoint: false,
                line:
                  'You may withdraw your consent to receive Communications electronically by contacting us as set out in Section 15 below. Withdrawal of consent may prohibit you from using the ftcash Services and may close your Account.',
              },
            ]  
          },
          {
            title: "How to contact us regarding electronic Communications",
            paragraph:[
              {
                subpoint: false,
                line:
                  'If you have any questions regarding our policy on electronic Communications, please email us at support@ftcash.com or call us at +91 983-349-6939',
              },
            ]         
          },     
          {
            title:"Fees",
            paragraph:[
              {
                subpoint: false,
                line:
                  'FT Cash Fee. For each FT Cash payment, you make or receive, FT Cash may charge a fee ("FT Cash Fee") as specified. By default, the recipient, such as a merchant, is charged the FT Cash Fee, and payer will not be charged the FT Cash Fee. Transaction fee charges would not be refunded/ reversed under any circumstances for any refund/ reversal /chargeback and any other reasons.',
              },
            ]
          },
          {
            title:'Facilitator Fee',
            paragraph:[
              {
                subpoint: false,
                line:
                  'The recipient, such as a seller, or a third party facilitating your payment transaction ("Facilitator") may charge you additional service fees ("Facilitator Fee") based on their terms and conditions. We recommend that you review Facilitator Fee terms before completing your payment.',
              },
            ]
          },
          {
            title:'Reversal Fee',
            paragraph:[
              {
                subpoint: false,
                line:
                  'If a payment that you received is subject to a Reversal as set out in Section 22 (Transaction reversal), you may be charged a fee of Rs 500.00 ("Reversal Fee").',
              },
            ]
          },
          {
            title:'Transaction Limits',
          paragraph:[
              {
                subpoint: false,
                line:
                  'Account limits. You are limited on the amount of money that can be sent from your Account per transaction. The per transaction limit is currently Rs. 25,000. We reserve the right to decrease your transaction limit at any time, for any reason.',
              },
            ]
          },
          {
            title:'Increased Limits',
            paragraph:[
              {
                subpoint: false,
                line:
                  'You may apply for an increased sending limit here. Approval is solely in ftcashs discretion and may be reassessed and/or revoked at any time.',
              },
            ]
          },
          {
            title:'Funding source limitations',
            paragraph:[
              {
                subpoint: false,
                line:
                  'Recipient Limitation. A recipient, such as a seller, may choose not to accept all forms of ftcash funding sources. This means you may not be able to choose from the full range of funding sources you have available in your Account to complete your payment to that recipient.',
              },
            ]
          },
          {
            title:'Transaction reversal',
          paragraph:[
            {
                subpoint: false,
                line:
                  'Transaction reversal Reversals or Chargebacks. Any payment that you (merchant) receive may be reversed if:',
              },
              {
                subpoint: true,
                line:[
                  {
                    point:'the sender (payer/customer) requests a reversal of the payment if the terms of the service are not met,'
                  },
                  {
                    point:"the sender's bank requests a reversal of the payment, or"
                  },
                  {
                    point:'FT Cash decides a Dispute against you (each a "Reversal").'
                  },
                ]       
              },
              {
                subpoint: false,
                line:
                  "You are liable to FT Cash for the full amount of any payment that you receive that is subject to a Reversal, and the Reversal Fee, if applied. You will not receive a refund of any FT Cash Fee that you may have paid. In cases where the transaction is reversed at the customer's behest and with the consent of the merchant, prior to the payout for this transaction being released to the merchant, the FT Cash Fee will be charged to the customer.",
              },
            ]
          },
          {
            title:'Authorization to recover amounts due',
          paragraph:[
            {
                subpoint: false,
                line:
                  'You authorize ftcash to recover any Reversal amounts due to the Financial Institution Partner by debiting your available ftcash Balance. If you have an insufficient ftcash Balance, you authorize ftcash and the Financial Institution Partner to take any of the following actions to recover the remaining amounts from you:',
              },
              {
                subpoint: true,
                line:[
                  {
                    point:'Debit the bank or credit union account(s) linked to your Account;'
                  },
                  {
                    point:"Suspend your Account and require your immediate payment; or"
                  },
                  {
                    point:'Engage in collection efforts.'
                  },
                ]            
              },
            ]
          },
          {
            title: "Cancellation Policy",
            paragraph:[
              {
                subpoint: false,
                line:
                  'The customer should contact the merchant directly in order to receive a refund. Once the merchant agrees to process the refund, they can intimate ftcash to process the refund to the customer. ftcash will process the refund in the next 3 working days and it may take up to 7 business days for the refund to show ion the customer’s account. Fees once paid which are non-refundable for any reason or any clause of Nomisma mobile Solutions Pvt ltd.',
              },
            ]        
          },
          {
            title: "USER CONDUCT",
            paragraph:[
              {
                subpoint: false,
                line:
                  ' ',
              },
            ]      
          },
          {
            title: "Restricted",
            paragraph:[
              {
                subpoint: false,
                line:
                  'You agree that in connection with your use of the ftcash Services and your interactions with ftcash you will not:',
              },
              {
                subpoint: true,
                line:[
                  {
                    point:'Breach these Terms or any other ftcash terms or policies that you have accepted;'
                  },
                  {
                    point:"Provide false or inaccurate information to ftcash, including identity information;"
                  },
                  {
                    point:'Engage or attempt to engage in illegal or fraudulent activities;'
                  },
                ]    
              },
              {
                subpoint: false,
                line:
                  'The following kinds of service providers or merchants are excluded and will not be allowed to sign up for ftcash Merchant Services-',
              },
              {
                subpoint: true,
                line:[
                  {
                    point:'Firearms, Alcoholic beverages, Explosives, Pornography materials and services of any kind whatsoever, Live animals, Banned / illegal drugs or other controlled substances, Fireworks or pyrotechnic devices or supplies, Hazardous materials, combustibles, on line gambling including Rummy, corrosives, Website access and / or website memberships of pornography or illegal sites.'
                  },
                  {
                    point:"Bulk email software, Gambling transactions, Multilevel marketing collection fees, Matrix sites or sites using a matrix scheme approach, Mailing lists"
                  },
                  {
                    point:'Drop-shipped merchandise, Internet pharmacies, software downloads , wall-papers / screen-savers downloads, downloads from web-site/system which cannot be authenticated by way of proof of delivery, any product or service which is not in compliance with all applicable laws and regulations whether federal, state, local or international including laws of India.'
                  },
                  {
                    point:'Jewelers excluding sale of artificial and imitation jewelry, Antique item dealers, Art Gallery, Builder/ Construction companies/Building material suppliers, Local Cable operators, Chit funds/ Nidhi companies/ Credit societies/money lenders/financiers/small NBFCs, Handicraft dealers, Customs notified shops, Journalists /advocates / computer consultants Commission agents, Lottery agencies, Money changers, Motor training school, Medical stores, Real estate agencies/ agents / brokers, Plantation/ Time resort/Marriage Bureaus, Card brokers,Job Placement Services and Companies,Loyalty programs who are selling fixed holidays packages and Merchants who provide tech support.'
                  },
                  {
                    point:'Engage in activity that indicates, in ftcash and the Financial Institution Partners discretion, that there may be a high level of risk associated with you, your Account, or any of your Account activity.'
                  },
                ]           
              },
            ]   
          },
          {
            title: "ftcash Product-Specific Terms",
            paragraph:[
              {
                subpoint: false,
                line:
                  ' ',
              },
            ]   
          },
          {
            title: "Referral Program",
            paragraph:[
              {
                subpoint: false,
                line:
                  'ftcash offers a referral program which allows you to earn ftcash Referral credits for new customer referrals ("Referral Program"). Referral credits are not transferable and may not be auctioned, traded, bartered, sold, or redeemed for any value other than provided in these Terms.',
              },
              {
                subpoint: false,
                line:
                  'Referral credits can only be used to pay for items through ftcash. Upon termination of the Referral Program or any portion thereof for any reason, or Referral credits can expire or be terminated at any time at ftcashs sole discretion.',
              },
            ]  
          },
          {
            title: "Disputes with other ftcash users",
            paragraph:[
              {
                subpoint: false,
                line:
                  'Dispute resolution. You understand and agree that ftcash is not responsible for the goods or services that you pay for using the ftcash Services. Each seller that you purchase from is responsible for providing the goods and services that you purchase and for providing all customer service related to those goods and services. We recommend that you review a sellers policies before completing your purchase. You are responsible for resolving any disputes that you may have with a seller. If you have exhausted all options for resolving a dispute with a seller, you may choose to file a dispute claim with ftcash ("Dispute") by following the steps in Section 4 below.',
              },
            ]   
          },
          {
            title: "Release of ftcash",
            paragraph:[
              {
                subpoint: false,
                line:
                  'By filing a Dispute, you understand and agree that:',
              },
              {
                subpoint: true,
                line:[
                  {
                    point:'You are asking ftcash to assist in resolving the dispute in its sole discretion and that such assistance or ftcashs decision may not be satisfactory to you;'
                  },
                  {
                    point:"ftcashs assistance in resolving the dispute does not guarantee any particular outcome nor any action on ftcashs part; and"
                  },
                  {
                    point:'You release ftcash, our officers, directors, agents, employees, and suppliers from all claims, demands and damages of any kind arising out of your dispute with a seller and ftcashs review of your Dispute.'
                  },
                ]      
              },
            ] 
          },
          {
            title: "How to file a Dispute",
            paragraph:[
              {
                subpoint: false,
                line:
                  'To file a Dispute, follow these steps:',
              },
              {
                subpoint: false,
                line:
                  'Within 45 days of the original transaction, email support@ftcash.com with the following information:',
              },
              {
                subpoint: true,
                line:[
                  {
                    point:'The mobile numbers, email addresses and names of both parties, if available,'
                  },
                  {
                    point:"The transaction ID number,"
                  },
                  {
                    point:'The amount of the transaction, and'
                  },
                  {
                    point:'The details of your disagreement with the recipient, including any steps already taken to resolve the issue and copies of supporting documentation (such as email correspondence, receipts, etc.).'
                  },
                  {
                    point:'Provide any additional information or documentation that we may request. Once ftcash has decided the outcome of the Dispute, the parties will be notified of the decision. You are required to comply with the decision and complete any actions required by such decision.'
                  },
                ]              
              },
            ]         
          },
          {
            title: "Your liability and actions we may take",
            paragraph:[
              {
                subpoint: false,
                line:
                  'Your liability. You are responsible for all Reversals, chargebacks, claims, fees, fines, penalties and other liability incurred by ftcash, the Financial Institution Partner, other ftcash users, or third parties arising from your breach of these Terms or your use of the ftcash Services. You agree to reimburse ftcash, the Financial Institution Partner, other ftcash users, or third parties for any and all such liability.',
              },
            ]
          },
          {
            title: "Actions we may take",
            paragraph:[
              {
                subpoint: false,
                line:
                  'If we determine, in our sole discretion, that you may have breached these Terms, that you or your Account activity present risk or security concerns, or if we are unable to verify your identity, we may take actions to protect ftcash and our users, the Financial Institution Partner, or other third parties from Reversals, claims, fines, penalties and any other liability. These actions may include, but are not limited to, the following:',
              },
              {
                subpoint: true,
                line:[
                  {
                    point:'Suspending your access to your Account and/or the ftcash Services;'
                  },
                  {
                    point:"Suspending your access to your funds held in the Holding Account for up to 90 days"
                  },
                  {
                    point:'Taking action as set out in Section 6 (Transaction reversal) to recover amounts that you owe;'
                  },
                  {
                    point:'Closing your Account;'
                  },
                  {
                    point:'Contacting ftcash users or third parties who have purchased goods or services from you, contacting your bank, and/or warning other ftcash users, law enforcement, or other impacted third parties of your actions;'
                  },
                  {
                    point:'Refusing to provide the ftcash Services to you in the future; and'
                  },
                  {
                    point:'Taking legal action against you.'
                  }
                ]       
              },
            ]
          },
          {
            title: "Notice of limit or suspension",
            paragraph:[
              {
                subpoint: false,
                line:
                  'We will provide you with notice if we take any of the above actions against your Account. If we limit or suspend your Account, we will provide you with notice of our action.',
              },
            ]
          },
          {
            title: "Unauthorized transactions and Error resolution",
            paragraph:[
              {
                subpoint: false,
                line:
                  'Notify ftcash of Account Errors. Contact ftcash immediately at support@ftcash.com if you think that:',
              },
              {
                subpoint: true,
                line:[
                  {
                    point:'your Account has been accessed without your authorization'
                  },
                  {
                    point:"a transaction that you did not authorize has occurred"
                  },
                  {
                    point:'a transaction has been processed incorrectly to or from your Account, or'
                  },
                  {
                    point:'your Account statement contains an error regarding your transaction history (each, an "Error"). '
                  },
                ]  
              },
              {
                subpoint: false,
                line:
                  'If you give someone access to your Account and they conduct transactions without your authorization, these transactions are not considered Errors, unless you are the victim of a phishing attack or similar exploit. We must hear from you within 30 days after we provided the Account statement on which the suspected Error first appeared.',
              },
            ]
          },
          {
            title: "How to notify ftcash",
            paragraph:[
              {
                subpoint: false,
                line:
                  'When you notify us of the suspected Error, please provide:',
              },
              {
                subpoint: true,
                line:[
                  {
                    point:'Your name and Email Address,'
                  },
                  {
                    point:"The nature of the suspected Error and why you believe it is an Error, and"
                  },
                  {
                    point:'The transaction amount of the suspected Error.'
                  },    
                ]    
              },
              {
                subpoint: false,
                line:
                  'If you notify us by phone, we may require that you send us your inquiry by email within 10 business days.',
              },
            ]
          },
          {
            title: "Investigation by ftcash",
            paragraph:[
              {
                subpoint: false,
                line:
                  'We will determine whether an Error occurred within 10 business days after you notify us and will correct any Error promptly. If we need more time, we may take up to 45 days to investigate. If we decide to do this, we will credit your Account within 10 business days for the amount of the suspected Error. If we ask you to send your inquiry by email and we do not receive it within 10 business days, we may not credit your Account. For Errors involving new Accounts, we may take up to 90 days to investigate and may take up to 20 business days to credit your Account.',
              },
            ]
          },
          {
            title: "Investigation results",
            paragraph:[
              {
                subpoint: false,
                line:
                  'ftcash will tell you the results within 3 business days after completing our investigation. If we decide that there was no Error, we will provide you a written explanation. You may ask for copies of the documents that we used in our investigation.',
              },
            ]
          },
          {
            title: "Termination",
            paragraph:[
              {
                subpoint: false,
                line:
                  'ftcash will tell you the results within 3 business days after completing our investigation. If we decide that there was no Error, we will provide you a written explanation. You may ask for copies of the documents that we used in our investigation.',
              },
              {
                subpoint: true,
                line:[
                  {
                    point:'By You- You may stop using the ftcash Services at any time. You may also close your Account at any time, as long as you have no pending transactions or open Disputes, by contacting us at support@ftcash.com.'
                  },
                  {
                    point:"By Us. We may close your Account or terminate your access to the ftcash Services without liability, for any reason, upon notice to you. Reasons for termination may include, but are not limited to, your violation of these Terms or any other applicable ftcash or the Financial Institution Partner terms or policies, Account inactivity, or ftcashs assessment that you pose an unacceptable risk to the ftcash network, based on our confidential risk and security criteria. ftcash also reserves the right to modify or terminate the ftcash Services at any time, for any reason."
                  },
                ]  
              },
              {
                subpoint: false,
                line:
                  'If you notify us by phone, we may require that you send us your inquiry by email within 10 business days.',
              },
            ]
          },
          {
            title: "Disputes with ftcash",
            paragraph:[
              {
                subpoint: false,
                line:
                  'Binding arbitration-You and we (the "Parties") agree that upon the election of either of the Parties, any past, present, or future dispute relating in any way to your Account, or any other past, present, or future relationship or transaction between the Parties, will be resolved by binding arbitration as discussed below, and not through litigation in any court. Such disputes are called "Claims" for purposes of this agreement. This binding agreement to arbitrate applies regardless of whether the dispute is between you and us jointly or separately. Unless the Parties agree otherwise, or unless the arbitration administrators rules or law require otherwise, the arbitration shall be held in Mumbai, Maharashtra, India.',
              },
              {
                subpoint: false,
                line:
                  'The arbitrator will decide the Claim in accordance with all applicable law, including recognized principles of equity and statutes of limitations, and will honor all privileges recognized by law. The arbitrator will have the authority to award to a Party any damages or relief provided for under applicable law. The arbitrators decision shall be final and legally binding, and may be enforced by any court having jurisdiction.',
              },
              {
                subpoint: false,
                line:
                  'No class actions or similar process, and no joinder or consolidation of any Claim with a Claim of any other person or entity, shall be allowable in arbitration, without the written consent of both Parties. The arbitrator shall have no authority to entertain any Claim on behalf of a class, group, person, or entity who is not a named party to the arbitration, nor shall any arbitrator have authority to make any award for the benefit of, or against, any class, group, person, or entity who is not a named party to the arbitration. In the event that there is a dispute about whether limiting arbitration to non-class proceedings, or to the named parties, is enforceable under applicable law, then that question shall be resolved by a court rather than by an arbitrator; and to the extent it is determined that resolution of a Claim must proceed on a class basis, it shall so proceed in a court of competent jurisdiction rather than in arbitration.',
              },
              {
                subpoint: false,
                line:
                  'If the arbitrator or arbitration administrator would impose filing fees or other administrative costs on you, we will reimburse you, upon request, to the extent such fees or costs would exceed those that you would otherwise have to pay if you were proceeding instead in a court. We will also pay additional fees or costs if required to do so by the arbitration administrators rules or applicable law. Apart from the foregoing, each Party will be responsible for any other fees or costs, such as attorney fees that the Party may incur.',
              },
              {
                subpoint: false,
                line:
                  'Arbitration with respect to a Claim is binding and neither Party will have the right to litigate that Claim through a court. In arbitration the Parties will not have the same rights that apply in court, such as the right to a trial by judge or jury and the right to participate or be represented in proceedings brought by others such as class actions or similar proceedings. In addition, the right to discovery and the right to appeal may also be limited or eliminated in arbitration. All of these judicial rights are waived with respect to Claims that the Parties elect to arbitrate.',
              },
            ]
          },
          {
            title: "Complete agreement, no waiver, and survival",
            paragraph:[
              {
                subpoint: false,
                line:
                  'ftcash will tell you the results within 3 business days after completing our investigation. If we decide that there was no Error, we will provide you a written explanation. You may ask for copies of the documents that we used in our investigation.These Terms, along with any applicable ftcash terms and policies that you have agreed to set forth the entire understanding between you and ftcash with respect to the ftcash Services. Any failure of ftcash or to enforce any right or provision of these Terms shall not constitute a waiver of such right or provision. Any provision of these Terms held to be invalid or unenforceable under applicable law shall be struck, and the remaining provisions will continue in full force and effect. Sections: Using ftcash, Consent to receive electronic Communications, Transaction reversal, Disputes with other ftcash users, Your liability and actions ftcash and the Financial Institution Partner may take, Disputes with ftcash, and General terms, as well as any other terms which by their nature should survive, will survive the termination of these Terms.',
              },
              {
                subpoint: false,
                line:
                  'I/We further acknowledge and agree that for My/Our application to be considered, evaluated, and verified, FTCash and/or its lending partners may download My/Our KYC records from the Central KYC Records Registry (CKYCR) and I/We further consent and undertake that the KYC information provided by Me/Us at anytime for availing any loan facility are the same as available on the CKYCR and in the event of any mismatch, FTCash and/or its lending partners shall have the right to reject/cancel My/Our application or loan facility at any time.',
              },
            ]
          },
          {
            title: "Definitions",
            paragraph:[
              {
                subpoint: false,
                line:
                  '"Account" means a ftcash Personal Account, Business Account, Government Account, or Non-profit Account.',
              },
              {
                subpoint: false,
                line:
                  '"Business Account" means an Account established primarily for business purposes and not primarily for personal, family, or household purposes.',
              },
              {
                subpoint: false,
                line:
                  '"Communications" means the communications described in Section Communications.',
              },
              {
                subpoint: false,
                line:
                  '"Dispute" means a dispute claim filed with ftcash as described in Section "Dispute resolution".',
              },
              {
                subpoint: false,
                line:
                  '"ftcash" means ftcash and its successors, affiliates, or assigns.',
              },
              {
                subpoint: false,
                line:
                  '"ftcash Services" means all products and services, including Accounts, offered by ftcash through our websites, applications, or through any other means.',
              },
              {
                subpoint: false,
                line:
                  '"Facilitator" means a third party or third party software that facilitates your payment as described in Section "Facilitator Fee".',
              },
              {
                subpoint: false,
                line:
                  '"Facilitator Fee" means the fee charged by a Facilitator.',
              },
              {
                subpoint: false,
                line:
                  '"Financial Institution Partner" means the partner bank that is handling the credit / debit card processing, etc.',
              },
              {
                subpoint: false,
                line:
                  '"Government Account" means an Account established by a government entity primarily for government purposes and not for personal, family, or household purposes.',
              },
              {
                subpoint: false,
                line:
                  '"Non-profit Account" means an Account established primarily for non-profit purposes and not for personal, family, or household purposes.',
              },
              {
                subpoint: false,
                line:
                  '"Referral Program" means the program described in Section "Referral Program".',
              },
              {
                subpoint: false,
                line:
                  '"Reversal Fee" means the fee that may be charged for any Reversal associated with your Account.',
              },
              {
                subpoint: false,
                line:
                  '"Reversal" means ftcashs reversal of a payment you received because: (a) the sender requests a reversal of the payment, (b) the senders bank or credit union requests a reversal of the payment, or (c) ftcash decides a Dispute against you.',
              },
              {
                subpoint: false,
                line:
                  '"Terms" means these ftcash Terms of Service, as may be amended from time to time.',
              },
              {
                subpoint: false,
                line:
                  '"Us", "we" or "our" refers to ftcash and the Financial Institution Partner.',
              },
              {
                subpoint: false,
                line:
                  '"Virtual Currency" means a medium of exchange that operates like a currency in some environments, does not have all the attributes of real currency, and is subject to regulatory guidance. Virtual Currency includes cryptocurrencies, including, but not limited to Bitcoin, Litecoin, Namecoin, and Peercoin.',
              },
              {
                subpoint: false,
                line:
                  '"You" or "your" means any person or entity using the ftcash Services.',
              },
              {
                subpoint: false,
                line:
                  'Financial institutions play an important role in the ftcash network.',
              },
              {
                subpoint: false,
                line:
                  '2020 ftcash Terms of Use',
              },
            ]
          },
          {
            title: "Other Terms & conditions",
            paragraph:[
              {
                subpoint: true,
                line:[
                  {
                    point: '1. Payment: No cash/bearer cheque has been collected from me up-front towards processing the loan application.',
                  },
                  {
                    point: '2. No discount/fees gifts or any other commitment is given whatsoever which is not documented in the loan agreement by the lender or any of its authorized representative(s).',
                  },
                  {
                    point: 'Notwithstanding anything to the contrary contained in these Terms, in case inconsistency or conflict between these (i) Terms and loan documentation to be entered into between the lending partners of ftcash and the users of ftcash, then terms and condition of the loan documentation shall prevail to the extent of such conflict or inconsistency; and (ii) Terms and privacy policy of ftcash, then terms and condition of the privacy policy shall prevail to the extent of such conflict or inconsistency.',
                  }
                ]
              },
            ]
          },
        ]
      };
    },

    mounted() 
    {

      //  if (localStorage.getItem('reloaded')) {
      //       // The page was just reloaded. Clear the value from local storage
      //       // so that it will reload the next time this page is visited.
      //       localStorage.removeItem('reloaded');
      //   } else {
      //       // Set a flag so that we know not to reload the page twice.
      //       localStorage.setItem('reloaded', '1');
      //       location.reload();
      //   }

      this.$refs.tncstart.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
      // window.scrollTo(0, 0);
    },
    metaInfo() 
    {
      return{
      
      link: [
        { rel: 'canonical', href: 'https://www.ftcash.com/tnc' },
      ],
      }
    },
  }
</script>
<style scoped>
body {         
  height: auto;
  line-height: 1.6;
  overflow: auto;
}
#terms-and-conditions {
  overflow-y: hidden;
}
.termsintro-section {
  height: 100vh;
  background-image: url("../../assets/terms_conditions_bg.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
   background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
}

/* Media Queries */
/* Tablet Screen */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  
  section#terms-intro-section {
    height: 50vh;
  }
}
/* Mobile Screen */
@media (min-width: 481px) and (max-width: 767px) {
  section#terms-intro-section {
    height: 55vh;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    scroll-snap-align: center;
  }
}
@media (max-width: 480px) {
  section#terms-intro-section {
    height: 200vh;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    scroll-snap-align: center;
  }
}
</style>